import { FormatSubType, FormatType } from "@/constants/tagular/main";

/** Eventing matrix htmlId for the search modal bottom CTA. */
export const SEARCH_BAR_FOOTER_CTA_HTML_ID = "search-bar-footer-cta";

export type SearchBarProductListingContext = "default-state" | "after-query";

export type SearchBarProductEventFormat = {
  formatType: FormatType;
  formatSubtype: FormatSubType;
};

/** Map listing surface to Tagular formatType/formatSubtype per the v2 eventing matrix. */
export function getSearchBarProductEventFormat(
  listingContext: SearchBarProductListingContext,
): SearchBarProductEventFormat {
  if (listingContext === "after-query") {
    return {
      formatType: FormatType.Search,
      formatSubtype: FormatSubType.SearchRecommendation,
    };
  }

  return {
    formatType: FormatType.ProductCard,
    formatSubtype: FormatSubType.HorizontallyStacked,
  };
}
